import createComponent, {
  type ElementWithProps
} from '@carvana/merch-components/createComponent';
import cx from 'classnames';
import { useMemo } from 'react';
import { useLocationContext } from '~/context/common/LocationContext';
import useVideo from '~/hooks/common/ui/useVideo';
import { geoModalAssets } from './assets';

const Video = createComponent<ElementWithProps<{ videoLoaded: boolean }>>(
  'video',
  ({ videoLoaded }) => ({
    className: cx('h-full w-full transition-opacity duration-200 u:opacity-0', {
      'opacity-100': videoLoaded
    })
  })
);

type MediaComponentProps = {
  imageUrl: string;
  videoUrl: string;
};

function MediaComponent({ imageUrl, videoUrl }: MediaComponentProps) {
  const { videoRef, videoLoaded, handleVideoLoaded } = useVideo();

  return (
    <div className="relative h-[164px] w-full sm:h-[624px] md:h-[509px]">
      {videoUrl && (
        <Video
          autoPlay
          className="absolute"
          controls
          loading="lazy"
          loop
          muted
          onLoadedData={handleVideoLoaded}
          playsInline
          preload="none"
          poster={imageUrl}
          ref={videoRef}
          src={videoUrl}
          videoLoaded={videoLoaded}
        />
      )}
    </div>
  );
}

export default function MediaContent() {
  const { isDeliveryAllowed, pickUpInfoToDisplay } = useLocationContext();
  const hasVMPickup = pickUpInfoToDisplay?.locationType === 'VendingMachine';

  return useMemo(() => {
    switch (true) {
      case isDeliveryAllowed:
        return (
          <MediaComponent
            imageUrl={geoModalAssets.desktopDeliveryImage}
            videoUrl={geoModalAssets.desktopDeliveryVideo}
          />
        );
      case hasVMPickup:
        return (
          <MediaComponent
            imageUrl={geoModalAssets.vMDesktopImage}
            videoUrl={geoModalAssets.vMDesktopVideo}
          />
        );
      default:
        return null;
    }
  }, [hasVMPickup, isDeliveryAllowed]);
}
